import React from "react";
import {Box, Drawer, Grid, List} from "@mui/material";
import {useRecoilState, useRecoilValue} from "recoil";
import {AppointmentBottomDrawerListItem} from "./AppointmentBottomDrawerListItem";
import '../../styles/BottomDrawerStyle.scss';
import {getShortenDateWithDayOfWeek} from "../../utils/Utils";
import {bottomDrawerPollInfoState, openBottomDrawerState} from "../../states/appointment/overviewAtom";

export const AppointmentBottomDrawer: React.FC = () => {
    const [openBottomDrawer, setOpenBottomDrawer] = useRecoilState(openBottomDrawerState);
    const bottomDrawerPollInfo = useRecoilValue(bottomDrawerPollInfoState);

    return (
        <Drawer open={openBottomDrawer} onClose={() => setOpenBottomDrawer(false)} anchor={'bottom'}
                PaperProps={{ style: {maxWidth: '430px', borderTopLeftRadius: 30, borderTopRightRadius: 30} }}>
            <Box sx={{height: 350}} role="presentation" padding={'27px 16px 0px 16px'}>
                {getBottomDrawerContent()}
            </Box>
        </Drawer>
    )

    function getBottomDrawerContent(): React.JSX.Element {
        let listItems = bottomDrawerPollInfo?.pollData.map((data) => {
            return <AppointmentBottomDrawerListItem key={data.member.id} member={data.member} attendType={data.attendType}/>
        })

        if (!listItems || listItems.length === 0) {
            return (
                <Box paddingBottom={'24px'} height={'100%'}>
                    <span>{getShortenDateWithDayOfWeek(bottomDrawerPollInfo?.date ?? null)}</span>
                    <Grid container justifyContent={'center'} alignItems={'center'} height={'100%'} paddingBottom={'24px'}>
                        <Grid item>
                            <span>아직 이 날짜에 아무도 투표하지 않았어요.</span>
                        </Grid>
                    </Grid>
                </Box>
            )
        }

        return (
            <>
                <span>{getShortenDateWithDayOfWeek(bottomDrawerPollInfo!!.date)}</span>
                <List>
                    {listItems}
                </List>
            </>
        );
    }
}